import { lazy } from 'react';

// project import
import Loadable from 'components/Loadable';
import LandingLayout from 'layout/LandingLayout';

// render - login

const KitHome = Loadable(lazy(()=>import('pages/kithome')))
// ==============================|| AUTH ROUTING ||============================== //

const LandingRoutes = {
  path: '/',
  element: <LandingLayout />,
  children: [
    {
      path: '/kithome',
      element: <KitHome />
    },

  ]
};

export default LandingRoutes;
